var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"tool-total-row",class:{ 'tool-total-row-active': _vm.active },on:{"click":_vm.change}},[_vm._v(" SUM & AVG ")])}
var staticRenderFns = []

export { render, staticRenderFns }